/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { UserContext } from '@/data/types/UserContext';
// when preferredCurrency is not available, fallback to currency
export const getCurrencyParamFromContext = (context?: UserContext) => {
	let currency = context?.globalization?.preferredCurrency;
	if (!currency) {
		currency = context?.globalization?.currency;
	}
	return currency
		? {
				currency,
		  }
		: ({} as any);
};
